import { render, staticRenderFns } from "./SBAllergiesAddEdit.vue?vue&type=template&id=f5319802"
import script from "./SBAllergiesAddEdit.vue?vue&type=script&lang=js"
export * from "./SBAllergiesAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports